// import React from "react";
// import './blog.css'
// import ButtonBlog from "./ButtonBlog";
// import Gfooter from "../Component/Gfooter";
// import Blog5 from "./Blog5";
// import Card1 from "./Card1";

// function Blog() {
//   return (
//     <div className="blog-top">
//     <nav className="navbar bg-body-tertiary">
//       <div className="container box-blog">
//         <h1 className="navbar-brand">Blogs</h1>
//         {/* <p className="dot"></p> */}
//         {/* <form className="d-flex" role="search">
//           <input
//             className="form-control me-2"
//             type="search"
//             placeholder="Search Topics"
//             aria-label="Search"
//           />
//           <i className="fa-solid fa-magnifying-glass search-icon" />
//         </form> */}
//       </div>
//     </nav>


//     <Card1/>
//       <ButtonBlog/>
// <Gfooter/>
//     </div>
//   );
// }

// export default Blog;


import React, { useEffect, useState } from "react";
import { Helmet } from 'react-helmet-async';
import { Link } from "react-router-dom";
import axios from "axios";
import "./BlogCard.css";
import Gfooter from "../Component/Gfooter";

function Blog() {
  const [blogCards, setBlogCards] = useState([]);

  useEffect(() => {
    const fetchBlogCards = async () => {
      try {
        const response = await axios.get(
          "https://cyberathon.com/NLF/index.php/Api/Nlf_Controller/list_blog_card"
        );

        if (response.data.status === true) {
          setBlogCards(response.data.data || []);
        }
      } catch (error) {
        console.error("Error fetching blog cards:", error);
      }
    };

    fetchBlogCards();
  }, []);

  return (
    <>

      <Helmet>
        <title>Architecture, Design & Product Insights | NLF</title>
        <meta
          name="description"
          content="Read NLF's latest insights on architecture, facade design, ceilings, interiors, furniture, sustainability, trends and architectural products."
        />
        <link rel="canonical" href="https://nlfs.in/blog" />
        <meta property="og:title" content="Architecture, Design & Product Insights | NLF" />
        <meta property="og:description" content="Read NLF's latest insights on architecture, facade design, ceilings, interiors, furniture, sustainability, trends and architectural products." />
      </Helmet>
      <h1 style={{ display: 'none' }}>Architecture & Design Insights</h1>
      <section className="blog-section">
        <div className="container">

          {/* Center Heading */}
          <div className="row">
            <div className="col-12 text-center mb-5">
              <h2 className="blog-heading text-dark">Blogs</h2>
            </div>
          </div>

          {/* Blog Cards */}
          <div className="row">
            {blogCards.map((blog) => (
              <div
                key={blog.id}
                className="col-lg-3 col-md-6 col-sm-6 mb-4"
              >
                <div className="blog_boxcontent">
                  <div className="upper_portion">
                    <img
                      src={`https://cyberathon.com/NLF/${blog.blog_image}`}
                      alt={blog.title}
                    />
                  </div>

                  <div className="lower_portion_wrapper">
                    <div className="lower_portion">
                      <h4>{blog.title}</h4>
                    </div>

                    <Link
                      to={`/blog/${blog.id}`}
                      className="read_more"
                    ><span className="d-flex d-inline-flex justify-content-center align-items-center">
                        Read More</span>
                    </Link>
                  </div>
                </div>
              </div>
            ))}
          </div>

        </div>
      </section>

      <Gfooter />
    </>
  );
}

export default Blog;